import { useEffect } from 'react'
import { APP_NAME } from '@shared/brand'
import { titlePrefix } from '@/lib/worktreeLabel'
import { loadingDocumentTitle } from '@/lib/commonStrings'
import { releaseTitle, reportTitle } from '@/lib/pageTitleBridge'

// Joins title segments and appends the app name: pageTitle('Set times', 'Shambhala')
// → "Set times · Shambhala · Beacon". Keeps the brand out of translated strings.
export function pageTitle(...parts: string[]): string {
  return [...parts, APP_NAME].join(' · ')
}

// Pass null while the page's data is loading: the tab shows a placeholder and
// the route's page_view waits for the real title. Runs on native too — nothing
// shows a WebView's title, but trackPageView reports it as page_title (#399).
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    document.title = titlePrefix + (title ?? loadingDocumentTitle())
    reportTitle(title === null ? 'loading' : 'settled')
    return () => {
      document.title = titlePrefix + APP_NAME
      releaseTitle()
    }
  }, [title])
}
